import { SDK, ServerOptions } from '@commercetools/frontend-sdk';
import {
  GetShoppingListsAction,
  CreateShoppingListAction,
  UpdateShoppingListAction,
  GetMyProjectsAction,
  DeleteProjectAction,
  CloneProjectAction,
  SuggestUserNames,
  GetProjectMetadata,
  GetProjectCategories,
} from '../../types/actions/ProjectBuilderAction';
import { ComposableCommerceEventsB2B } from '../../types/events/ComposableCommerceEventsB2B';

export type ProjectBuilderActions = {
  getMyProjects: GetMyProjectsAction;
  getShoppingLists: GetShoppingListsAction;
  createShoppingList: CreateShoppingListAction;
  updateShoppingList: UpdateShoppingListAction;
  getMyProjectsDashboard: GetMyProjectsAction;
  getMyProjectsDashboardV2: GetMyProjectsAction;
  getProjectById: GetMyProjectsAction;
  performMutationOnMyProjectById: UpdateShoppingListAction;
  deleteProject: DeleteProjectAction;
  updateProjectStatus: UpdateShoppingListAction;
  cloneProject: CloneProjectAction;
  suggestUserNames:SuggestUserNames;
  getProjectMetadata:GetProjectMetadata;
  getProjectCategories:GetProjectCategories;
};

export const getProjectBuilderAction = (sdk: SDK<ComposableCommerceEventsB2B>): ProjectBuilderActions => {
  return {
 
    getShoppingLists: async (
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/getShoppingLists',
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });
      return response;
    },
    getMyProjects: async (
      payload?: any,
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/getMyProjects',
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
        payload,
      });
      return response;
    },
    getMyProjectsDashboard: async (
      payload?: any,
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/getMyProjectsDashboard',
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
        payload,
      });
      return response;
    },
    getMyProjectsDashboardV2: async (
      payload?: any,
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/getMyProjectsDashboardV2',
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
        payload,
      });
      return response;
    },
    getProjectById: async (
      payload?: any,
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/getMyProjectById',
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
        payload,
      });
      return response;
    },
    performMutationOnMyProjectById: async (
      payload?: any,
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/performMutationOnMyProjectById',
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
        payload,
      });
      return response;
    },
    createShoppingList: async (
      payload: any,
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/createShoppingList',
        payload,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });
      return response;
    },
    updateShoppingList: async (
      payload: any,
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/updateShoppingList',
        payload,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });
      return response;
    },

    deleteProject: async (
      payload?: any,
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/deleteProject',
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
        payload,
      });
      return response;
    },
    updateProjectStatus: async (
      payload: any,
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/updateProjectStatus',
        payload,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });
      return response;
    },

    cloneProject: async (
      payload?: any,
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/cloneProject',
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
        payload,
      });
      return response;
    },
    suggestUserNames: async (
      payload?: any,
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/suggestUserNames',
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
        payload,
      });
      return response;
    },     
    getProjectMetadata: async (
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/getProjectMetadata',
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });
      return response;
    },
    getProjectCategories: async (
      payload?: any,
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/getProjectCategories',
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
        payload,
      });
      return response;
    }, 
  };
};

